import { Loader2 } from 'lucide-react';

// Jednotný loading state pro data fetching.
// Použití:
//   <LoadingState />                             // default "Načítání…"
//   <LoadingState message="Generuji PDF…" />
//   <LoadingState size="sm" />                   // malý inline

const SIZES = {
  sm: { padding: 'py-4', icon: 'w-5 h-5' },
  md: { padding: 'py-12', icon: 'w-8 h-8' },
  lg: { padding: 'py-20', icon: 'w-10 h-10' },
};

export default function LoadingState({
  message = 'Načítání…',
  size = 'md',
  className = '',
}) {
  const s = SIZES[size] || SIZES.md;
  return (
    <div className={`flex flex-col items-center justify-center text-center ${s.padding} ${className}`}>
      <Loader2 className={`${s.icon} animate-spin mb-2`} style={{ color: 'var(--ct-accent)' }} />
      {message && (
        <p className="text-xs" style={{ color: 'var(--ct-text-secondary)' }}>
          {message}
        </p>
      )}
    </div>
  );
}
